export default "__VITE_ASSET__N_Wdf65b__"